import * as React from 'react'

function IconChange(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={34}
      height={35}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.233 8.559a8.223 8.223 0 00-5.822 2.414A8.245 8.245 0 002 16.803v7.488a8.25 8.25 0 002.413 5.826 8.227 8.227 0 005.82 2.412h7.479a8.221 8.221 0 005.817-2.413 8.243 8.243 0 002.41-5.825"
        stroke="#3C3C3B"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M26.975 14.147l-7.48-6.66-6.328 7.616a11.778 11.778 0 00-2.963 8.163v0a2.488 2.488 0 001.705 2.288c.322.106.662.145 1 .114v0a11.714 11.714 0 007.743-3.9l6.323-7.621zM29.868 3.264a5.012 5.012 0 00-7.076.421l-.179.277 7.48 6.665.178-.277a5.027 5.027 0 00-.403-7.086v0zM13.156 15.108l7.49 6.66M23.227 10.816l-6.329 7.622"
        stroke="#3C3C3B"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconChange
